import { type ProspectDto } from '@api'
import { type ColumnDef } from '@tanstack/react-table'

import LinkIcon from '@/assets/icons/icon-external.svg'
import { getCountryNameByCode } from '@/components/ui/CountrySelect/constants'
import { Tag } from '@/components/ui/tag'

import { ProspectActions } from '../prospect-actions/ProspectActions'

const formatWebsiteUrl = (website: string) => {
  if (website.startsWith('http')) {
    return website
  }

  return `https://${website}`
}

const formatWebsiteName = (website: string) => {
  if (website.includes('onlyfans.com')) {
    return 'OnlyFans'
  }
  const domain = new URL(website).hostname

  return domain.replace('www.', '').split('.')[0]
}

export const PROSPECTS_TABLE_COLUMNS: ColumnDef<ProspectDto>[] = [
  {
    id: 'name',
    header: 'Prospect Name',
    accessorKey: 'name',
    enableSorting: true,
  },
  {
    id: 'website',
    header: 'Website',
    accessorKey: 'website',
    cell: ({ getValue }) => (
      <a
        href={formatWebsiteUrl(getValue<string>())}
        target="_blank"
        rel="noreferrer"
        className="flex items-center capitalize underline underline-offset-2"
      >
        {formatWebsiteName(getValue<string>())}
        <LinkIcon className="ml-1 h-3 w-3" />
      </a>
    ),
    enableSorting: true,
  },
  {
    id: 'country',
    header: 'Country',
    accessorKey: 'country',
    cell: ({ row }) => getCountryNameByCode(row.original.country),
    enableSorting: false,
  },
  {
    id: 'onlyFansUser',
    header: 'OnlyFans',
    accessorKey: 'onlyfans',
    cell: ({ row }) => {
      const hasOF = row.original.onlyFansUser

      return (
        <Tag variant={hasOF ? 'success' : 'danger'}>
          {hasOF ? 'Owned' : 'Not Owned'}
        </Tag>
      )
    },
    enableSorting: true,
  },
  {
    id: 'actions',
    enableSorting: false,
    header: () => <div className="flex w-full justify-end">Actions</div>,
    cell: ({ row }) => <ProspectActions row={row} />,
  },
]
